import KnowMore from "@/components/ui/know-more";
import Section from "@/components/ui/section";
import { memo } from "react";

const About = memo(({ homeText }) =>{
  return (
    <Section className="bg-beige">
      <div className="flex flex-col w-full items-center justify-center gap-2">
        {/* Display the header dynamically */}
        {homeText?.header && (
          <h1 className="font-havletica font-light uppercase text-[#333333]/80 text-center lg:max-w-[741px] text-[25px]">
            {homeText.header}
          </h1>
        )}

        <div className="lg:max-w-[591px] w-full border-b-[1px] border-[#121111]/20 my-6" />

        {/* Display the main description */}
        {homeText?.desc && (
          <p className="text-[#121111]/70 text-center lg:max-w-[999px] font-light">
            {homeText.desc}
          </p>
        )}

        {/* Static description as fallback or additional content */}
        <p className="text-[#121111]/70 text-center lg:max-w-[999px] font-light">
          Chalk Studio is an interior design firm that believes in thoughtfully designing impactful spaces.
        </p>

        {/* Display the additional description dynamically */}
        {homeText?.desc1 && (
          <p className="text-[#121111]/70 text-center lg:max-w-[999px] font-light mt-4">
            {homeText.desc1}
          </p>
        )}

        {/* Know More Button */}
        <KnowMore className="mt-12" path="/about">
          Know More
        </KnowMore>
      </div>
    </Section>
  );
});

About.displayName = "About";

export default About;